const getYmmQuery = /* GraphQL */ `
  query GetYmm($request: YmmRequestInput! = null) {
    ymmData: ymm(request: $request) {
      years {
        displayName
        optionId
      }
      prioritizedMakes {
        displayName
        optionId
      }
      makes {
        displayName
        optionId
      }
      models {
        displayName
        optionId
        shopUrl
        shopUrlWithSelectedFacets
        searchUrl
        searchUrlWithSelectedFacets
        marketId
        superMarketId
        vehicleBaseId
      }
      stockEngines {
        displayName
        optionId
        shopUrl
        searchUrl
        shopUrlWithSelectedFacets
        searchUrlWithSelectedFacets
        engineIds {
          engineManufacturerId
          engineMakeId
          engineSeriesId
          engineConfigurationId
          engineQualifierId
          engineVersionId
          engineDisplacementId
          engineCodeId
          engineCamshaftTypeId
          engineFuelSystemId
        }
      }
    }
  }
`

export default getYmmQuery
